import React from 'react';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import { CircularProgress } from '@material-ui/core';
import { Form } from '@sketchpixy/rubix';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { BLUE, GREEN } from '../../_config/consts';
import MDButton from '../MDButton/MDButton.jsx';
import CardDetailsRow from '../Cards/CardDetailsRow.jsx';
import CustomField from './Fields/CustomField.jsx';
import _ from 'lodash';
import InfoSection from '../InfoSection/InfoSection.jsx';
import { sortEncodersByPreference, getPreferredEncoders } from '../../_config/utils';

const validate = (values) => {
  const errors = {};
  if (!values.encoderId) {
    errors.encoderId = 'required';
  }
  return errors;
};

@reduxForm({ form: 'StandardDeviceEncodeForm', validate })
@connect((state) => ({form: state.form.StandardDeviceEncodeForm}))
class StandardDeviceEncodeForm extends React.Component {
  componentDidMount() {
    this.onAutoSelectEncoder();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.encoders !== this.props.encoders) {
      this.onAutoSelectEncoder();
    }
  }

  onAutoSelectEncoder() {
    const { encoders, dispatch, form } = this.props;
    
    if (!encoders || _.isEmpty(encoders) || form?.values?.encoderId) {
      return;
    }

    const preferredEncoders = _.filter(encoders, (encoder) => 
      getPreferredEncoders().includes(encoder.encoderId)
    );

    if (encoders.length === 1) {
      dispatch(change('StandardDeviceEncodeForm', 'encoderId', encoders[0].encoderId));
    } else if (preferredEncoders.length === 1) {
      dispatch(change('StandardDeviceEncodeForm', 'encoderId', preferredEncoders[0].encoderId));
    }
  }

  render() {
    const { card, encoders, isLoading, errorMessage, success, form, handleSubmit } = this.props;
    const encoderId = form?.values?.encoderId;

    return (
      <Form style={{ padding: 20, minWidth: 500 }}>
        <div style={{ marginBottom: 20, zoom: 0.9 }}>
          <CardDetailsRow 
            card={card}
            privateUnits={[]}
            hideHeader
          />
        </div>
        <InfoSection
          title="cardEncodingExplanation"
          gravity="info"
          titleStyle={{ fontWeight: 'normal' }}
          containerStyle={{ marginTop: 0, marginBottom: 20 }}
        />
        <Field
          id="encoderId"
          name="encoderId"
          title={<Entity entity="selectEncoder" />}
          component={CustomField}
          mandatory
          disabled={_.isEmpty(encoders) || isLoading}
          className="form-control-select"
          componentClass="select"
        >
          <option value="">
            {L20NContext.getSync('selectEncoder')}
          </option>
          {_.map(sortEncodersByPreference(encoders), encoder => {
            const isPreferred = getPreferredEncoders().includes(encoder.encoderId);
            return (
              <option key={encoder.encoderId} value={encoder.encoderId}>
                {`${isPreferred ? '⭐ ' : ''}${encoder.name} (${encoder.deviceType})`}
              </option>
            );
          })}
        </Field>

        {_.isEmpty(encoders) && (
          <div style={{ padding: 10, backgroundColor: '#fff3e0', borderRadius: 8, marginBottom: 20, marginTop: 20 }}>
            <h5 style={{ margin: 0, color: '#f57c00' }}>
              <Entity entity="noEncodersAvailable" />
            </h5>
          </div>
        )}
        
        <MDButton
          title={<Entity entity="writeCard" />}
          backgroundColor={GREEN}
          onClick={handleSubmit}
          disabled={!encoderId || _.isEmpty(encoders) || isLoading}
          containerStyle={{ marginTop: 20 }}
        />

        {isLoading && (
          <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 20 }}>
            <CircularProgress size={50} style={{ color: BLUE }} />
            <h4 style={{ marginTop: 15, color: '#3f3f3f', marginBottom: 5 }}>
              <Entity entity="waitingForCard" />
            </h4>
            <p style={{ color: '#7f7f7f', margin: 0, fontSize: 14 }}>
              <Entity entity="pleaseHoldCardNearEncoder" />
            </p>
          </div>
        )}
        {success && !isLoading && (
          <InfoSection
            title="cardEncodedSuccessfully"
            subtitle="cardHasBeenWrittenSuccessfully"
            gravity="success"
            containerStyle={{ marginTop: 20 }}
          />
        )}
        {errorMessage && !isLoading && (
          <InfoSection
            title="encodingFailed"
            subtitle={<Entity entity={errorMessage} />}
            gravity="error"
            containerStyle={{ marginTop: 20 }}
          />
        )}
      </Form>
    );
  }
}

export default StandardDeviceEncodeForm;
